import { ApplicationConstants } from '../../../../shared/applicationConstants';
import { SharedService } from '../../../../shared/services/sharedService';
import { AuthService } from '../../../../login/services/authService.js';

export class DuplicarMapaService {

    static copyMap(businessId, nom){
        let token = AuthService.getToken();
        let uid = AuthService.getUid();
        return SharedService.httpPost(ApplicationConstants.duplicateMapUrl, { uid: uid, token: token, businessId: businessId, nom: nom}).then((response) => {
            if (response && response.body) {
                if (response.body.status === "ERROR") {
                    return response.body;
                }
                else {
                   return response.body;
                }
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/perfil/components/duplicar-modal/services/duplicarMapaService.js